import "./HeroImage.css";
import React from "react";
import IntroImage from "../../assets/intro-bg.jpg";
import { Link } from "react-router-dom";
import { TypeAnimation } from 'react-type-animation';

function HeroImage() {
  return (
    <div className="hero">
      <div className="mask">
        <img className="intro-img" src={IntroImage} alt="IntroImage" />
      </div>
      <div className="content">
        <p>HI I'M A</p>
        <div>
          <TypeAnimation
            sequence={[
              "React Developer",
              1000,
              "MERN Stack Developer",
              1000,
              "React Native Developer",
              1000,
            ]}
            repeat={Infinity}
          />
        </div>
        <div>
          <Link to="/projects" className="btn">
            Projects
          </Link>
          <Link to="/contact" className="btn btn-light">
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
}

export default HeroImage;
